<template>
  <v-menu offset-y :width="width">
    <div class="services-popover card">
      <div
        v-for="(group, groupIndex) of groups"
        :key="groupIndex"
        class="services-row"
      >
        <NavigationItem
          v-for="(item, itemIndex) of group"
          :key="itemIndex"
          :name="item.name"
          :link="item.link"
          :new-tab="item.newTab"
          :material-icon="item.icon"
          :text="item.text"
        />
      </div>
    </div>

    <template v-slot:activator="{ on }">
      <slot name="reference" :on="on" />
    </template>
  </v-menu>
</template>

<script>
import NavigationItem from "./NavigationItem.vue";
import { mapState } from "vuex";
import { chunk } from "@/utils/Array";

export default {
  components: {
    NavigationItem
  },

  props: {
    width: {
      type: Number,
      default: 380
    },

    itemsPerRow: {
      type: Number,
      default: 3
    },

    items: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...mapState("auth", ["currentUser"]),

    groups() {
      return chunk(this.items, this.itemsPerRow);
    }
  }
};
</script>

<style lang="css" scoped>
.services-popover {
  padding: 1em 1.25em;
  z-index: 9999;
}

.services-row {
  display: flex;
  justify-content: flex-start;
}
</style>
